import { Badge } from "../lib/ui";

const STATE_TONE = {
  ADOPTED: "green",
  GUIDING: "cyan",
  EXCEPTION: "rose",
  UNKNOWN: "amber",
  NOT_APPLICABLE: "slate",
};

export default function StrategyChain({ strategy, showTaxonomy = false }) {
  if (!strategy) return null;
  const chain = strategy.chain || [];
  const contest = strategy.contest || {};
  const catalog = strategy.catalog || {};
  const rails = strategy.guardrails || [];
  const rec = strategy.recommendation || {};
  const paths = contest.paths || [];
  const winner = contest.winner;

  return (
    <section className="feature-panel strategy-chain-panel" data-testid="strategy-chain">
      <div className="panel-header">
        <div>
          <p className="kicker">STRATEGY → GUARDRAILS → ASSESSMENT → RECOMMENDATION</p>
          <h2>Replatform vs Refactor against enterprise technology strategy</h2>
        </div>
        <Badge tone="cyan">Not an authorized MDR</Badge>
      </div>
      <p className="muted small-note">{catalog.rule || "Strategy constrains eligibility. UNKNOWN is not adopted. AI cannot change stance."}</p>

      <ol className="strategy-chain" data-testid="strategy-chain-steps">
        {chain.map((step, index) => (
          <li key={step.id} data-testid={`strategy-step-${step.id}`}>
            <em>{index + 1}</em>
            <strong>{step.label}</strong>
            <span>{step.detail}</span>
          </li>
        ))}
      </ol>

      {showTaxonomy && (catalog.domains || []).length > 0 && (
        <div className="strategy-taxonomy" data-testid="strategy-taxonomy">
          {(catalog.domains || []).map((domain) => (
            <div key={domain.id} className="strategy-domain" data-testid={`strategy-domain-${domain.id}`}>
              <p className="kicker">{domain.label}</p>
              {(domain.principles || []).map((p) => (
                <div key={p.id} className="strategy-principle">
                  <strong>{p.label}</strong>
                  <Badge tone={STATE_TONE[p.state] || "slate"}>{p.state}</Badge>
                  <small>{p.note}</small>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {rails.length > 0 && (
        <div className="strategy-rails" data-testid="strategy-guardrails">
          {rails.map((rail) => (
            <div key={rail.id} className={`strategy-rail ${rail.kind}`}>
              <Badge tone={rail.kind === "block" ? "rose" : "green"}>{rail.kind === "block" ? "EXCEPTION" : "ADOPTED"}</Badge>
              <div>
                <strong>{rail.label}</strong>
                <p>{rail.rule}</p>
                <small>Evidence · {rail.evidence}</small>
              </div>
            </div>
          ))}
        </div>
      )}

      {!contest.applicable ? (
        <div className="strategy-na" data-testid="strategy-contest-na">
          <strong>Contest not applicable</strong>
          <p>{contest.reason || rec.why?.[0]}</p>
        </div>
      ) : (
        <>
          <div className="strategy-compare" data-testid="strategy-compare">
            <div className="strategy-compare-head">
              <span>Path</span>
              <span>Alignment</span>
              <span>Cost</span>
              <span>Complexity</span>
              <span>Risk</span>
              <span>Eligible</span>
            </div>
            {paths.map((path) => (
              <div
                key={path.family}
                className={`strategy-compare-row ${path.family === winner ? "winner" : ""}`}
                data-testid={`strategy-path-${path.family.toLowerCase()}`}
              >
                <span>
                  <b>{path.family}</b>
                  {path.family === winner && <em> · Stronger alignment</em>}
                </span>
                <span><b>{path.alignment}</b></span>
                <span>{path.cost?.amount || "UNKNOWN"}</span>
                <span>{path.complexity?.index}</span>
                <span>{path.risk?.label || "UNKNOWN"}</span>
                <Badge tone={path.eligible ? "green" : "rose"}>{path.eligibility}</Badge>
              </div>
            ))}
          </div>
          <div className="strategy-verdict" data-testid="strategy-recommendation">
            <p className="kicker">RECOMMENDATION · STRONGER STRATEGIC ALIGNMENT</p>
            <h3 data-testid="strategy-winner">{rec.strategy || winner}</h3>
            <p>{contest.rule}</p>
            <p className="muted small-note">{contest.tradeoff || rec.tradeoff}</p>
            <ul>
              {(rec.why || contest.why || []).map((item) => <li key={item}>{item}</li>)}
            </ul>
            <small>{rec.authorization}</small>
          </div>
        </>
      )}
    </section>
  );
}
